import * as types from './types';

const type = {
  GET: types.GET_USER_ACTIVITY,
  PUT: types.PUT_USER_ACTIVITY,
  POST: types.POST_USER_ACTIVITY,
  DELETE: types.DELETE_USER_ACTIVITY
};

const apiRequest = (method = 'GET', path = '', queryParams = null, id = '', body = null, cronut = '') => ({
  type: type[method],
  meta: {
    async: true,
    api: 'users',
    path: `/v1/users/me/${path}${id}${cronut}`,
    query: queryParams,
    body,
    method
  }
});

const apiFrequencies = () => ({
  type: types.GET_FREQUENCIES,
  meta: {
    async: true,
    api: 'users',
    path: '/v1/users/me/alerts/frequencies',
    method: 'GET'
  }
});

const getUnReadMessageCounter = () => ({
  type: types.GET_MESSAGES_UNREAD,
  meta: {
    async: true,
    api: 'leads',
    path: '/seeker/leads/count/unread',
    method: 'GET'
  }
});

export { apiRequest, apiFrequencies, getUnReadMessageCounter };
